import {
  getUserVars as fetchUserVars,
  getUserVar as fetchUserVarValue,
  setUserVar as postUserVarValue,
  USER_VARIABLE,
} from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { SetUserVar, UserVar, UserVarValue } from '@nx-frontend/shared/types';

export async function getUserVars(userId: number): Promise<UserVar[]> {
  let userVars: UserVar[] = [];

  try {
    userVars = await fetchUserVars({ host: generalEnv.userServiceUrl, userId });
  } catch (err) {
    console.error(`getUserVars error: ${err}`);
  }

  return userVars;
}

export async function getUserVarValue(userId: number, key: USER_VARIABLE): Promise<UserVarValue | null> {
  let userVar: UserVar | null = null;

  try {
    userVar = await fetchUserVarValue({ host: generalEnv.userServiceUrl, userId, key });
  } catch (err) {
    console.error(`getUserVarValue error: ${err}`);
  }

  if (!userVar) {
    return null;
  }

  const result = userVar.value as UserVarValue;
  return result || null;
}

export async function setUserVarValue({ userId, key, value }: SetUserVar): Promise<UserVarValue | null> {
  let userVar: UserVar | null = null;

  try {
    userVar = await postUserVarValue({ host: generalEnv.userServiceUrl, userId, key, value });
  } catch (err) {
    console.error(`setUserVarValue error: ${err}`);
  }

  if (!userVar) {
    return null;
  }

  const result = userVar.value as UserVarValue;
  return result || null;
}
